(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name tracking.constant:trackingConstants
     *
     * @description
     *
     */
    angular
        .module('tracking')
        .value('trackingConstants', {
            DESCRIPANCY_TYPES : {
            OPEN_PAIR: 'OPEN_PAIR',
            NEXT_ILLEGAL: 'NEXT_ILLEGAL',
            CURR_ILLEGAL: 'CURR_ILLEGAL',
            GENDER_WARNING: 'GENDER_WARNING',
            LANG_WARNING: 'LANG_WARNING',
            EXP_WARNING: 'EXP_WARNING'
        }

})
    ;
}());
